import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import "../../static/css/offerBanner.css";
import {
  OFFER_COPY,
  formatOfferEndLabel,
  getActiveOfferEndDate,
  getTimeRemaining,
} from "../../data/offerConfig";

const pad = (value) => String(value).padStart(2, "0");

class OfferBanner extends React.Component {
  constructor(props) {
    super(props);
    this.offerEndDate = getActiveOfferEndDate();
    this.state = {
      timeLeft: getTimeRemaining(this.offerEndDate),
    };
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.setState({ timeLeft: getTimeRemaining(this.offerEndDate) });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  renderTimerUnits() {
    const { timeLeft } = this.state;
    const units = [];

    if (timeLeft.days > 0) {
      units.push({ value: timeLeft.days, label: "Days" });
    }

    units.push(
      { value: timeLeft.hours, label: "Hours" },
      { value: timeLeft.minutes, label: "Minutes" },
      { value: timeLeft.seconds, label: "Seconds" }
    );

    return units.map((unit, index) => (
      <React.Fragment key={unit.label}>
        {index > 0 && <span className="timer-separator">:</span>}
        <div className="timer-box">
          <span className="timer-value">{pad(unit.value)}</span>
          <span className="timer-unit">{unit.label}</span>
        </div>
      </React.Fragment>
    ));
  }

  render() {
    const { timeLeft } = this.state;
    const endLabel = formatOfferEndLabel(this.offerEndDate);

    return (
      <section className="offer-banner-section">
        <div className="container">
          <motion.div
            className="offer-banner"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="offer-banner-content">
              <motion.div
                className="offer-badge"
                animate={{
                  scale: [1, 1.05, 1],
                  rotate: [0, -2, 2, -2, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              >
                <span className="offer-text">{OFFER_COPY.badge}</span>
              </motion.div>

              <div className="offer-main-content">
                <h2 className="offer-heading">
                  {OFFER_COPY.heading}{" "}
                  <span className="offer-highlight">{OFFER_COPY.highlight}</span>
                  {OFFER_COPY.headingSuffix}
                </h2>
                <p className="offer-description">{OFFER_COPY.description}</p>

                {!timeLeft.expired ? (
                  <div className="offer-timer">
                    <div className="timer-label">
                      Free demo slots this week (by {endLabel}) close in:
                    </div>
                    <div className="timer-display">{this.renderTimerUnits()}</div>
                  </div>
                ) : (
                  <div className="offer-timer offer-timer--expired">
                    <p className="offer-expired-message">{OFFER_COPY.expiredMessage}</p>
                  </div>
                )}

                <div className="offer-cta-buttons">
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Link to="/demo/" className="offer-cta-link">
                      <button className="offer-cta-button offer-cta-button--demo">
                        Book Free Demo
                        <span className="arrow">→</span>
                      </button>
                    </Link>
                  </motion.div>
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Link to="/all-courses/" className="offer-cta-link">
                      <button className="offer-cta-button">
                        Explore Courses
                        <span className="arrow">→</span>
                      </button>
                    </Link>
                  </motion.div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    );
  }
}

export default OfferBanner;
